<template>
  <div class="privacy page">
    <div class="article">
      <h2>개인정보처리방침</h2>
      <a href="/files/DukGO-privacy.pdf" download="privacy.pdf">
        파일로 보기 (pdf)
      </a>

      <h2>서비스이용약관</h2>
      <a href="/files/DukGO-service.pdf" download="service.pdf">
        파일로 보기 (pdf)
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>